import { collection, getDocs } from "firebase/firestore";
import { Collections, db } from "../../utils/firebase.config";
import { converterOf } from "../../utils/firebase.utils";
import Furniture from "../../entities/furniture.entity";

export const useFurnitures = () => {
  const furnituresCollection = collection(db, Collections.Furnitures).withConverter(converterOf(Furniture));

  const fetchAll = async (): Promise<Furniture[]> => {
    const furnitureDocs = await getDocs(furnituresCollection);

    return furnitureDocs.docs.map((furnitureDoc) => furnitureDoc.data());
  };

  return { fetchAll };
};


export default useFurnitures;
